import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { ComponentPropsWithoutRef, forwardRef, useEffect, useRef } from "react";

import { cn } from "@/lib/utils";

interface CollapsibleProps
  extends ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Root> {
  scrollIntoViewOnOpen?: boolean;
}

const Collapsible = forwardRef<HTMLDivElement, CollapsibleProps>(
  ({ scrollIntoViewOnOpen, onOpenChange, className, ...props }, ref) => {
    const internalRef = useRef<HTMLDivElement>(null);
    const resolvedRef = (ref as React.RefObject<HTMLDivElement>) ?? internalRef;

    useEffect(() => {
      if (scrollIntoViewOnOpen && props.open && resolvedRef.current) {
        resolvedRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, [props.open, scrollIntoViewOnOpen, resolvedRef]);

    return (
      <CollapsiblePrimitive.Root
        ref={resolvedRef}
        onOpenChange={onOpenChange}
        className={cn(className)}
        {...props}
      />
    );
  },
);
Collapsible.displayName = "Collapsible";

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
